export default {
  isDark: true,
  color: {
    backgroundLight1: '#fff',
    backgroundLight2: 'rgba(250,250,250,1)',
    grey1: 'rgba(51,51,51,1)',
    grey2: 'rgba(79,79,79,1)',
    darkGrey1: 'rgba(38,38,38,1)',
    grey3: 'rgba(97,97,97,0.8)',
    secondary: 'rgba(8,109,160,1)',
    primary: 'rgba(72,158,215,1)',
    success: '#52c41a',
    error: '#ff4d4f',
  },
  shadow: {
    dark1: 'drop-shadow(0px 8px 10px rgba(94, 96, 105, 0.2))',
  },
};
